import { render, staticRenderFns } from "./OrderLogTable.vue?vue&type=template&id=52c0bf42"
import script from "./OrderLogTable.vue?vue&type=script&lang=ts"
export * from "./OrderLogTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports